import * as React from 'react'
const styles = require('./styles')
interface ViewMoreQuotesProps {
  onViewMoreOffers: () => void
}
export const ViewMoreQuotes: React.FC<ViewMoreQuotesProps> = ({ onViewMoreOffers }: ViewMoreQuotesProps) => (
  <div className={styles.partnerContainer}>
    <img
      src="https://images.evenfinancial.com/logos/prod/life-insurance-assets/legal-general.svg"
      alt="Legal & General"
      width="80"
      className={styles.partnerIcon}
    />
    <img
      src="https://images.evenfinancial.com/logos/prod/life-insurance-assets/pacific-life.svg"
      alt="Pacific Life"
      width="80"
      className={styles.partnerIcon}
    />
    <img
      src="https://images.evenfinancial.com/logos/prod/life-insurance-assets/protective.svg"
      alt="Protective"
      width="80"
      className={styles.partnerIcon}
    />
    <img
      src="https://images.evenfinancial.com/logos/prod/life-insurance-assets/moo.svg"
      alt="Mutual of Omaha"
      width="89.83"
      height="18.94"
      className={styles.partnerIcon}
    />
    <img
      src="https://images.evenfinancial.com/logos/prod/life-insurance-assets/lincoln.svg"
      alt="Lincoln Financial Group"
      width="80"
      className={styles.partnerIcon}
    />
    <img
      src="https://images.evenfinancial.com/logos/prod/life-insurance-assets/assurity.svg"
      alt="Assurity"
      width="80"
      className={styles.partnerIcon}
    />
    <button
      data-testid="li-view-more"
      className={styles.viewMoreBtn}
      onClick={() => {
        onViewMoreOffers()
      }}
    >
      View More Quotes
    </button>
  </div>
)
